import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import { type CardLayoutModelConstructorType } from '../../types';

export class AssigneeName extends Field {
  static subqueriesForModel(
    modelClass: CardLayoutModelConstructorType
  ): Record<string, any> {
    switch (modelClass.typename) {
      case 'Task':
        return { users: ['name'] };

      default:
        return { assignedToUser: ['name'] };
    }
  }

  get title() {
    return 'Assignee name';
  }

  exampleContents(): FieldContentsData {
    return { text: 'Assigned to user' };
  }

  contentsForRecord(record): FieldContentsData {
    switch (record.typename) {
      case 'Task':
        return { text: record.users[0]?.name };

      default:
        return { text: record.assignedToUser?.name };
    }
  }
}
